import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {OPCUADevice} from "../../../../domain/opcua-device";
import {OPCUADataPoint} from "../../../../domain/opcua-data-point";
import {UnitConversionService} from "../../../../services/unit-conversion.service";
import {UnitConversion} from "../../../../domain/unit-conversion";

@Component({
  selector: 'eis-gateway-opcua-eis-core-unit-browser-dialog',
  templateUrl: './opcua-eis-core-unit-browser-dialog.component.html',
  styleUrls: ['./opcua-eis-core-unit-browser-dialog.component.scss']
})


export class OpcuaEisCoreUnitBrowserDialogComponent implements OnInit {

  public NONE_UNIT = "none";
  public selectedUnit = this.NONE_UNIT
  public factorValue: number = 1;
  public unitConversionList: UnitConversion[];
  public datapointName: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: { device: OPCUADevice, dataPoint: OPCUADataPoint },
              public dialogRef: MatDialogRef<OpcuaEisCoreUnitBrowserDialogComponent>,
              private unitConversionService: UnitConversionService,) {
  }

  ngOnInit(): void {
    this.datapointName= this.data.dataPoint.name
    this.unitConversionService.getAllUnitConversions().subscribe(unitList => {
        let unitMap = new Map()
        for (let unit of unitList) {
          unitMap.set(unit.endUnit,unit)
        }

        this.unitConversionList=[]
        for (let value of unitMap.values()) {
          this.unitConversionList.push(value)
        }
      },
      error => {
        console.log("Error loading unit conversions: ", error);
      })

  }

  closeDialog() {
    this.dialogRef.close();
  }

  save() {
    console.log('selected', this.factorValue, 'selectedUnit: ', this.selectedUnit);

    this.dialogRef.close(
      {
        unit: this.selectedUnit,
        scaleFactor: this.factorValue,
      });
  }

  resetUnit() {
    this.dialogRef.close({unit: this.NONE_UNIT});
  }

}
